import Vue from "vue";
import router from "@/router";
import Chartkik from "vue-chartkick";
import Chart from "chart.js";
import { VueSpinners } from "@saeris/vue-spinners";
import App from "./App.vue";
import { dollarFilter, percentFilter } from "@/filters";
import "@/assets/css/tailwind.css";

Vue.use(VueSpinners);
Vue.use(Chartkik.use(Chart));
Vue.filter("dollar", dollarFilter);
Vue.filter("percent", percentFilter);
Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
